import Constants from "expo-constants";

/**
 * Centralised API base URL.
 * Reads from app.json → extra.apiUrl at build time.
 * Falls back to the production URL if not set.
 *
 * For local development, change apiUrl in app.json extra
 * to your machine's LAN IP (e.g. "http://192.168.1.x:3002").
 */
export const API_URL: string =
  (Constants.expoConfig?.extra as Record<string, string> | undefined)
    ?.apiUrl ?? "https://api.khdame.com";
